import React from "react";
import TooltipComponent from "./TooltipComponent";

const TextBox = (props) => {
    return (
        <div>
            <label htmlFor={`${props.id}`} className="form-label">{props.label}</label>
            <input className="form-control" value={props.value} type={props.type} id={props.id} name={props.name} placeholder={props.hint} onChange={props.change} />
        </div>
    );
}

const TextArea = (props) => {

    return (
        <div>
            <label htmlFor="basiInput" className="form-label">{props.label}</label>
            <textarea className="form-control" value={props.value} type={props.type} id={props.id} name={props.name} placeholder={props.hint} onChange={props.change} />
        </div>
    );
}
const SubmitBtn = (props) => {
    return (
        props.status === true ? <button type="button" class={`btn btn-${props.type} btn-load`}><span class="d-flex align-items-center"><span class="flex-grow-1 me-2">Please wait...</span><span class="spinner-grow flex-shrink-0" role="status"><span class="visually-hidden">Please wait...</span></span></span></button>
            : <button type="submit" className={`btn btn-${props.type} btn-label waves-effect right waves-light float-right`}><i className={`${props.icon} label-icon align-middle fs-16 ms-2`} /> {props.text}</button>
    );
}
const SubmitButton = React.memo((props) => {
    const handleClick = (event) => {
      if (props.onClick) {
        props.onClick(event);
      }
    };
    // props.loading => Used for show loading
    // props.loadingMessage => Used for show message text while loading
    // props.type => Used for set color of button
    // props.otherClasses  => Used for add other css classes
    return props.loading === true ? (
      <button type="button" className={`btn btn-${props.type} btn-load`}>
        <span className="d-flex align-items-center">
          {/* props.loadingCss => this us used for add external css classes to make adjust size of loader */}
          <span class={`spinner-border flex-shrink-0 ${props.loadingCss} `} role="status">
            <span class="visually-hidden">{props.loadingMessage}...</span>
          </span>
          <span className="flex-grow-1 me-2 ps-1">{props.loadingMessage}...</span>
        </span>
      </button>
    ) : (
      <button
        type="submit"
        disabled={props.disabled}
        className={`btn btn-${props.type} ${props.otherClasses} btn-label waves-effect ${props.iconSide} waves-light float-${props.float}`}
        onClick={handleClick}
      >
        <i className={`${props.icon} label-icon align-middle fs-16`} />
        <span className="flex-grow-1 me-2">{props.buttonName}</span>
      </button>
    );
  });
  const IconButton = React.memo((props) => {
    const handleClick = (event) => {
      if (props.onClick) {
        props.onClick(event);
      }
    };
  
    return props.tooltipName && props.tooltipPosition ?
      (
        <TooltipComponent name={props.tooltipName} position={props.tooltipPosition}>
        <button
          disabled={props.disabled}
          onClick={()=> {if(!props.loading) handleClick();}}
          type="button"
          className={`btn-icon btn btn-sm btn-outline-${props.type}`}
        >
          {props.loading ? (
            <span class="spinner-border flex-shrink-0 smallLoader" role="status">
              <span class="visually-hidden">
                Loading...
              </span>
            </span>
          ) : (
            <i className={props.icon}></i>
          )}
        </button>
        </TooltipComponent>
      ):
      (
        <button
          disabled={props.disabled}
          onClick={()=> {if(!props.loading) handleClick();}}
          type="button"
          className={`btn-icon btn btn-sm btn-outline-${props.type}`}
        >
          {props.loading ? (
            <span class="spinner-border flex-shrink-0 smallLoader" role="status">
              <span class="visually-hidden">
                Loading...
              </span>
            </span>
          ) : (
            <i className={props.icon}></i>
          )}
        </button>
    )
  });
const IsRequired = () => {
    return (
        <span style={{ color: 'blue', marginLeft: 5, borderRadius: '50%', background: 'rgb(240, 248, 255)', textAlign: 'center', width: 20, height: 20, padding: '0px 5px' }}>*</span>
    );
}
export { TextBox, TextArea, SubmitBtn,SubmitButton, IconButton, IsRequired };